/* eslint-disable @reatom/unit-naming-rule */
import { atom, withAssign } from '@reatom/framework'

import { AsyncStateN, pipe } from '@blade/std-lib'
import { selectedNetworkAtom } from '@root/entities/network'
import { TradeSettings } from '@root/entities/trade-settings'
import { reatomRequest } from '@root/shared/lib'

import { fetchDefaultTradeSettingsRequestAction } from './trade-settings-requests'

export const reatomDefaultTradeSettings = () => {
  const defaultSettingsPresetsByNetworkStateAtom = reatomRequest({
    execAction: fetchDefaultTradeSettingsRequestAction,
    name: `defaultSettings`,
  })

  const networkDefaultSettingsPresetsStateAtom = atom((ctx) => {
    const state = ctx.spy(defaultSettingsPresetsByNetworkStateAtom)
    const network = ctx.spy(selectedNetworkAtom)
    return pipe(
      state,
      AsyncStateN.map((settings) => settings[network]),
    )
  }, 'networkDefaultSettingsStateAtom')

  const networkDefaultSettingsPresetStateAtom = atom((ctx) => {
    const state = ctx.spy(networkDefaultSettingsPresetsStateAtom)
    return pipe(
      state,
      AsyncStateN.map((settings) => {
        const activePreset = settings.activePresetIndex
        return settings.presets[activePreset]
      }),
    )
  }, 'networkDefaultSettingsStateAtom')

  const networkDefaultSettingsStateAtom = atom((ctx) => {
    const presetState = ctx.spy(networkDefaultSettingsPresetStateAtom)
    const network = ctx.spy(selectedNetworkAtom)
    return pipe(
      presetState,
      AsyncStateN.map((preset) => {
        return preset?.settings ?? TradeSettings.nullSettings(network)
      }),
    )
  }, 'networkDefaultSettingsStateAtom')

  return defaultSettingsPresetsByNetworkStateAtom.pipe(
    withAssign(() => ({
      networkDefaultSettingsState: networkDefaultSettingsStateAtom,
      networkDefaultSettingsPresetsState:
        networkDefaultSettingsPresetsStateAtom,
      networkDefaultSettingsPresetState: networkDefaultSettingsPresetStateAtom,

      loadDefaultSettings: defaultSettingsPresetsByNetworkStateAtom.execute,
    })),
  )
}
